import { getEarliestAvailableAdvanceBookingPeriod } from '../../utils/films/advance-booking-period-utils';
import { getFilmAvailability } from '../films/get-film-availability';
/**
 * Returns the earliest advance booking period available to the current patron for a particular film.
 *
 * Can optionally be limited to a particular booking mode.
 */
export const getAdvanceBookingPeriodForFilm = (filmId, siteId, bookingMode) => {
    const filmAvailability = getFilmAvailability(filmId, siteId);
    if (!filmAvailability)
        throw new Error(`Cannot find film availability with filmId: ${filmId}.`);
    return getEarliestAvailableAdvanceBookingPeriod(filmAvailability.advanceBookingPeriods, bookingMode);
};
